import { create } from 'zustand';
import { format, startOfMonth, endOfMonth } from 'date-fns';

import { PlannerTaskTab, TaskStatusFilter } from './types';

interface PlannerMessagesStore {
  tab: PlannerTaskTab;
  status: TaskStatusFilter;
  startDate: string;
  endDate: string;
  costCenterIds: string[];
  selectedTaskIds: string[];
  pageIndex: number;

  setTab: (tab: PlannerTaskTab) => void;
  setStatus: (status: TaskStatusFilter) => void;
  setDateRange: (startDate: string, endDate: string) => void;
  setCostCenterIds: (ids: string[]) => void;
  setSelectedTaskIds: (ids: string[]) => void;
  toggleTaskSelection: (taskId: string) => void;
  selectAllTasks: (taskIds: string[]) => void;
  clearSelection: () => void;
  setPageIndex: (index: number) => void;
  resetFilters: () => void;
}

const DATE_FORMAT = 'yyyy-MM-dd';

const getDefaultStartDate = () => format(startOfMonth(new Date()), DATE_FORMAT);

const getDefaultEndDate = () => format(endOfMonth(new Date()), DATE_FORMAT);

export const usePlannerMessagesStore = create<PlannerMessagesStore>((set) => ({
  tab: PlannerTaskTab.ALL,
  status: TaskStatusFilter.OPEN,
  startDate: getDefaultStartDate(),
  endDate: getDefaultEndDate(),
  costCenterIds: [],
  selectedTaskIds: [],
  pageIndex: 0,

  setTab: (tab) => set({ tab, selectedTaskIds: [], pageIndex: 0 }),
  setStatus: (status) => set({ status, selectedTaskIds: [], pageIndex: 0 }),
  setDateRange: (startDate, endDate) =>
    set({ startDate, endDate, selectedTaskIds: [], pageIndex: 0 }),
  setCostCenterIds: (costCenterIds) =>
    set({ costCenterIds, selectedTaskIds: [], pageIndex: 0 }),
  setSelectedTaskIds: (selectedTaskIds) => set({ selectedTaskIds }),
  toggleTaskSelection: (taskId) =>
    set((state) => ({
      selectedTaskIds: state.selectedTaskIds.includes(taskId)
        ? state.selectedTaskIds.filter((id) => id !== taskId)
        : [...state.selectedTaskIds, taskId]
    })),
  selectAllTasks: (taskIds) => set({ selectedTaskIds: taskIds }),
  clearSelection: () => set({ selectedTaskIds: [] }),
  setPageIndex: (pageIndex) => set({ pageIndex, selectedTaskIds: [] }),
  resetFilters: () =>
    set({
      tab: PlannerTaskTab.ALL,
      status: TaskStatusFilter.OPEN,
      startDate: getDefaultStartDate(),
      endDate: getDefaultEndDate(),
      costCenterIds: [],
      selectedTaskIds: [],
      pageIndex: 0
    })
}));
